import './Offers.css'
import Offer from "./Offer";
import Separator from "../separator/Separator";

const offers = [
    {
        title: 'Gratuit',
        color: '#5b9bd5',
        description: 'C\'est la maison qui offre',
        price: 0,
        services: [
            'Accès à des formation et ressources éducatives en ligne'
        ],
        features: [
            'Support technico-pédagogique sur les cultures et l’agroécologie ainsi que l’éducation environnemental en lignes en format vidéo – audio - pdf '
        ]
    },
    {
        title: 'Pro',
        color: '#ffc000',
        description: 'Une assistance avancée',
        price: '2 500',
        services: [
            'Accès à des formation et ressources éducatives en ligne',
            'Surveillance de culture avancée'
        ],
        features: [
            'Support technico-pédagogique sur les cultures et l’agroécologie ainsi que l’éducation environnemental en lignes en format vidéo – audio - pdf ',
            'Outils de gestion d’exploitation agricole digitale (sur web ou mobile) : aspect technique et financer'
        ]
    },
    {
        title: 'Pro+',
        color: '#94f319',
        description: 'Avec des conseils',
        price: '3 000',
        services: [
            'Accès à des formation et ressources éducatives en ligne',
            'Surveillance de culture avancée',
            'Conseil agronomique personnalisé en ligne ou sur terrain'
        ],
        features: [
            'Support technico-pédagogique sur les cultures et l’agroécologie ainsi que l’éducation environnemental en lignes en format vidéo – audio - pdf ',
            'Outils de gestion d’exploitation agricole digitale (sur web ou mobile) : aspect technique et financer',
            'Accompagnement et suivi personnalisés et en temps réel en cas de besoin '
        ]
    },
    {
        title: 'Premium',
        color: '#31bd37',
        description: 'Jusqu\'au marché',
        price: '4 000',
        services: [
            'Accès à des formation et ressources éducatives en ligne',
            'Surveillance de culture avancée',
            'Conseil agronomique personnalisé en ligne ou sur terrain',
            'Facilitation d’accès des producteurs au marché'
        ],
        features: [
            'Support technico-pédagogique sur les cultures et l’agroécologie ainsi que l’éducation environnemental en lignes en format vidéo – audio - pdf ',
            'Outils de gestion d’exploitation agricole digitale (sur web ou mobile) : aspect technique et financer',
            'Accompagnement et suivi personnalisés et en temps réel en cas de besoin ',
            'Plateforme de vente et d’achat des intrants, matériels et produits agricoles '
        ]
    },

]
const Offers = () => {
    return (
        <div className={"container offers-container"} id={"offers"}>
            <div className={"row"}>
                <div className={"col-12"}>
                    <h2 className={"title animate"}>Découvrez nos offres</h2>
                </div>
                {
                    offers.map(offer => (
                        <Offer offer={offer}></Offer>
                    ))
                }
            </div>

            <Separator  first={"legume/voatavo.webp"} second={"legume/corn.webp"} third={"legume/tomate.webp"}></Separator>
        </div>
    );
}

export default Offers;
